import { action, makeObservable, observable } from "mobx";
import SwayyWarehouseAPI from "../api/SwayyWarehouseAPI";
import { SwayyWarehouse } from "../../../models/SwayyWarehouse/SwayyWarehouse";

export class SwayyWarehouseStore {
  swayyWarehouseAPI: SwayyWarehouseAPI;
  warehouses: SwayyWarehouse[];
  loading: boolean;
  error: string | null;

  constructor() {
    this.swayyWarehouseAPI = new SwayyWarehouseAPI();
    this.warehouses = [];
    this.loading = false;
    this.error = null;

    makeObservable(this, {
      warehouses: observable,
      loading: observable,
      error: observable,
      getWarehouses: action,
      reset: action,
    });
  }

  getWarehouses = async () => {
    this.loading = true;
    this.error = null;
    try {
      const warehouses = await this.swayyWarehouseAPI.getWarehouses();
      this.warehouses = warehouses;
      return warehouses;
    } catch (error: any) {
      this.error = error?.message || "Failed to fetch warehouses";
      throw error;
    } finally {
      this.loading = false;
    }
  };

  reset = () => {
    this.warehouses = [];
    this.loading = false;
    this.error = null;
  };
}

export const swayyWarehouseStore = new SwayyWarehouseStore();
